import * as React from 'react';

import BaseLocationListLayout from './BaseLocationListLayout';

export default function (params) {
  return BaseLocationListLayout();
};
